﻿import { WorkFlowApproverItem } from "@/components/ApproverList/styled";
import { routes } from "@/helpers";
import {
  faArrowDown,
  faCirclePlus,
  faTrash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Space } from "antd";
import { any, bool, func, number, string } from "prop-types";
import { useNavigate } from "react-router-dom";

const PADDING_PER_LEVEL = 16;

const ApproverListItem = ({
  approver,
  approver: { id, name },
  padding = 0,
  handleModalToggle,
  approvalWorkflowId,
  header,
}) => {
  const navigate = useNavigate();
  const dependentApprover = approver.dependantApprovers?.[0];
  padding += PADDING_PER_LEVEL;
  return (
    <>
      <WorkFlowApproverItem
        style={{ paddingLeft: `${padding}px` }}
        header={header}
      >
        <Space size="middle">
          {!header && <FontAwesomeIcon icon={faArrowDown} />}
          {name}
          {
            // TODO: Preventing headers from being able to be deleted is temporary / will be reimplemented in
            // User Story 24422: Add validation on approval workflow
            // https://dev.azure.com/MilwaukeeToolAppDev/Moon%20Men/_workitems/edit/24422
            !header && (
              <Button
                type="link"
                data-test-id={`approver-list-approver-item-delete-${id}`}
                onClick={() => handleModalToggle(approver)}
                icon={<FontAwesomeIcon icon={faTrash} />}
              />
            )
          }
        </Space>
        {!dependentApprover && (
          <Button
            data-test-id={`add-approver-to-${id}`}
            type="link"
            onClick={() =>
              navigate(
                routes.admin.approvalWorkFlows.addDependentApprover(
                  approvalWorkflowId,
                  id
                )
              )
            }
            icon={<FontAwesomeIcon icon={faCirclePlus} />}
          />
        )}
      </WorkFlowApproverItem>
      {dependentApprover && (
        <ApproverListItem
          approver={dependentApprover}
          approvalWorkflowId={approvalWorkflowId}
          handleModalToggle={handleModalToggle}
          padding={padding}
        />
      )}
    </>
  );
};

ApproverListItem.propTypes = {
  approver: any.isRequired,
  handleModalToggle: func.isRequired,
  approvalWorkflowId: string.isRequired,
  padding: number,
  header: bool,
};

export default ApproverListItem;
